export default __webpack_public_path__ + "static/media/happy.0fd7c741.svg";